'use client';

import React from 'react';
import { useForwardSearchParams } from '../../hooks/navigation/useForwardSearchParams';
import { AE_PRICING_LINK_ABSOLUTE, ButtonLink } from '../shared';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './StartMetabolic.module.css';

const metabolicDevicesImg = getCompressedAssetUrl('/m1/metabolic-devices.png');

export const StartMetabolic = ({
  hideRequestAccess,
}: {
  hideRequestAccess?: boolean;
}) => {
  const forwardSearchParams = useForwardSearchParams();
  return (
    <div className={`${styles.container} u-grid`}>
      <div className={styles.content}>
        <h1 className={styles.title}>Start your metabolic fitness journey</h1>
        {!hideRequestAccess && (
          <ButtonLink
            className={styles.buttonLink}
            href={forwardSearchParams(AE_PRICING_LINK_ABSOLUTE)}
            size="m"
            rel="noopener noreferrer"
          >
            Buy now
          </ButtonLink>
        )}
      </div>
      <div
        className={styles.img}
        style={
          {
            ['--start-img']: `url('${metabolicDevicesImg}')`,
          } as React.CSSProperties
        }
      />
    </div>
  );
};
